import { EdgePostAnnouncementRepository } from '@/modules/connect/infra'
import type { PostAnnouncement } from '@/modules/connect/use-cases'
import { makeSupabaseEdgeHttpClient } from '@/main/factories/http'

export function makePostAnnouncement(): PostAnnouncement {
  return new EdgePostAnnouncementRepository(makeSupabaseEdgeHttpClient()).execute
}
